import { render } from "./paginator.vue?vue&type=template&id=4618b7ab&scoped=true"
import script from "./paginator.vue?vue&type=script&lang=js"
export * from "./paginator.vue?vue&type=script&lang=js"

import "./paginator.vue?vue&type=style&index=0&id=4618b7ab&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1199873226/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4618b7ab"]])

export default __exports__